// extracted by mini-css-extract-plugin
export var image = "styles-module--image--3PMyh";
export var imageWithCountContainer = "styles-module--imageWithCountContainer--URn8S";
export var photoCount = "styles-module--photoCount--2cwAC";
export var videoCount = "styles-module--videoCount--3nTTh";